import { render, staticRenderFns } from "./BsnDetailPopup.vue?vue&type=template&id=08736af3&"
import script from "./BsnDetailPopup.vue?vue&type=script&lang=js&"
export * from "./BsnDetailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports